import { ActionTree } from 'vuex';
import api from '../api';
import * as types from './types';



export default <ActionTree<workflow.state.WorkflowState, RootState>>{
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M M O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    [types.ADMIN_APPOPTIONLIST_LOAD](action, payload: workflow.RequestWorkflowOption){
        return api.common.getApplicationOptionList(payload)
            .then((res: workflow.CM_ApplicationOption) => {
                var list = res.optionList.map(x => {
                    return {
                        ...x,
                        optionValues: x.optionValues.map(y => {
                            return {
                                ...y,
                                isCommon: y.applicationId === undefined || y.applicationId === null
                            }
                        })
                    }
                })
                // console.log('ADMIN_APPOPTIONLIST_LOAD', 'list', list);
                res.optionList = list;
                // GLOBAL_INIT 에서 옵션을 조회할 경우 store 에 저장하지 않도록 함
                // 관리자 메뉴에서 접근시 전체 옵션이 목록에 처음에 보여지는 오류 방지
                if(payload.typeId > 0){
                    action.commit(types.ADMIN_APPOPTIONLIST_LOAD, res);
                }
                return res;
            })
        },

        [types.GET_WORKFLOW_OPTIONS](action, option: any): Promise<any>{
            const promises = [action.dispatch(types.ADMIN_APPOPTIONLIST_LOAD,{typeId: 0,} as workflow.RequestWorkflowOption)];
            return Promise.all(promises).then((results)=>{
                const options = results[0] as workflow.CM_ApplicationOption
                const appOptions = {optionList: options.optionList.filter((x) => x.optionItem.typeId === 1),
                } as workflow.CM_ApplicationOption // 양식 옵션
                const systemOptions = {
                    optionList: options.optionList.filter((x) => x.optionItem.typeId === 2),
                  } as workflow.CM_ApplicationOption // 시스템 옵션
                  var systemOption = {} as any
                systemOptions.optionList.forEach((x: workflow.CM_ApplicationOptionItem)=>{
                    if(x.optionItem.propertyName){
                        systemOption[x.optionItem.propertyName]=
                        x.optionValues[0].subOptionValue !== null
                        ? x.optionValues[0].subOptionValue
                        : x.optionValues[0].subOptionCode
                    }
                })
                var applicationOption = {} as any
                appOptions.optionList.forEach((x: workflow.CM_ApplicationOptionItem) => {
                  if (x.optionItem.propertyName) {
                    applicationOption[x.optionItem.propertyName] = x.optionValues.map((y) => {
                      if (y.subOptionValue !== null) {
                        return {
                          applicationId: y.applicationId,
                          value: y.subOptionValue,
                        } as any
                      } else {
                        return {
                          applicationId: y.applicationId,
                          value: y.subOptionCode,
                        } as any
                      }
                    })
                  }
                })
                var data = { system: systemOption, application: applicationOption }

                action.commit(types.GET_WORKFLOW_OPTIONS, data)
            })
           
        },

        
        [types.WORKFLOW_CURRENT](action, data: any) {
          return api.form.getForm(data).then(res => {
            action.commit(types.WORKFLOW_CURRENT,res)
            return res;
          })
        }
  


    } 
